export default "__VITE_PUBLIC_ASSET__c777d151__"